import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import GlobalHeader from "../../../UI/common/Layout/global-header";

const ErrorPage: React.FC<{}> = () => {
  const error = useRouteError();
  const isNotFound = isRouteErrorResponse(error) && error.status === 404;
  const title = isNotFound ? "Page Not Found" : "Something Went Wrong";
  const message = isNotFound
    ? "Oops! The page you're looking for doesn't exist."
    : "We hit an unexpected problem. Please try again in a moment.";

  return (
    <>
      <GlobalHeader />
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
        overflow: "hidden",
        padding: "104px 24px 24px",
        color: "white",
        textAlign: "center"
      }}>
        <h1 style={{ margin: "0 0 12px", color: "#FFAB00" }}>{title}</h1>
        <p style={{ maxWidth: "420px", margin: "0 0 24px", fontSize: "20px", lineHeight: 1.4 }}>{message}</p>
        <Link
          to="/"
          style={{
            color: "white",
            textDecoration: "none",
            borderRadius: "30px",
            padding: "10px 20px",
            background: "linear-gradient(90deg, #DA2612 0%, #9DD102 100%)"
          }}
        >
          Return Home
        </Link>
      </div>
    </>
  );
}

export default ErrorPage;
